module.exports = __webpack_public_path__ + "img/alter-ego_9-16_poster.7c0b7f7.jpg";